import React from "react";
import { useTranslation } from "react-i18next";
import sortIcon from "@surgia/ui/icons/table/sort.svg";
import { TableColumn, getHeaderClass, headerCellRightClass } from "./constants";

interface TableHeaderProps {
  columns: TableColumn[];
  onSort: (columnKey: string) => void;
  actions?: boolean;
  idColumnIcon?: string;
}

// Memoized header component
const TableHeader: React.FC<TableHeaderProps> = React.memo(
  ({ columns, onSort, actions, idColumnIcon }) => {
    const { t, i18n } = useTranslation();
    const RTL = i18n.language == "ar";
    return (
      <thead className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
        <tr>
          {columns
            .filter((column) => column.show !== false)
            .map((column) => (
              <th
                key={column.key}
                className={`${getHeaderClass(column.align)} ${RTL ? "text-right" : ""}`}
                onClick={() => onSort(column.key)}
                style={{
                  cursor: column.sortable ? "pointer" : "default",
                }}
              >
                {column.sortable ? (
                  <div className="flex items-center gap-1">
                    {idColumnIcon && column.key === "id" && (
                      <img
                        src={idColumnIcon}
                        alt="header-icon"
                        className="mr-1 cursor-not-allowed"
                      />
                    )}
                    {t(column.translationKey)}
                    <img src={sortIcon} alt="sort" className="w-3 h-3" />
                  </div>
                ) : (
                  <div className="flex items-center gap-1">
                    {idColumnIcon && column.key === "id" && (
                      <img
                        src={idColumnIcon}
                        alt="header-icon"
                        className="mr-1 cursor-not-allowed"
                      />
                    )}
                    {t(column.translationKey)}
                  </div>
                )}
              </th>
            ))}

          {actions && <th className={headerCellRightClass}>{t("actions")}</th>}
        </tr>
      </thead>
    );
  }
);

TableHeader.displayName = "TableHeader";

export default TableHeader;
